import React from 'react';
import { PricingResult, formatCurrency, formatEmailCount } from '../../utils/pricingCalculator';

interface PriceResultsProps {
  result: PricingResult;
  emailCount: number;
}

const PriceResults: React.FC<PriceResultsProps> = ({ result, emailCount }) => {
  const { monthlyPrice, discountPercentage, discountAmount, discountedPrice, currency, slab, emailsInLakhs } = result;


  return (
    <div className="price-results">
      {/* Main Price Display */}
      <div className="price-summary">
        <div className="price-main">
          <span className="price-amount">{formatCurrency(discountPercentage > 0 ? discountedPrice : monthlyPrice, currency)}</span>
          <span className="price-period">/month</span>
        </div>
        <div className="price-subtitle">
          for {new Intl.NumberFormat('en-IN').format(emailCount)} emails
          {discountPercentage > 0 && (
            <span className="discount-badge"> ({discountPercentage}% discount applied)</span>
          )}
        </div>
      </div>

      {/* Calculation Breakdown */}
      <div className="calculation-breakdown">
        <div className="breakdown-card">
          <div className="breakdown-header">
            <h4>Calculation Breakdown</h4>
            <span className="slab-badge">{slab.label}</span>
          </div>
          <div className="breakdown-details">
            <div className="breakdown-row">
              <span className="label">Your Volume:</span>
              <span className="value">{formatEmailCount(emailCount)} ({emailsInLakhs} lakh)</span>
            </div>
            <div className="breakdown-row">
              <span className="label">Rate per Lakh:</span>
              <span className="value">{formatCurrency(slab.pricePerLakh, currency)}</span>
            </div>
            <div className="breakdown-row calculation">
              <span className="label">Calculation:</span>
              <span className="value">{emailsInLakhs} × {formatCurrency(slab.pricePerLakh, currency)}</span>
            </div>
            <div className="breakdown-row">
              <span className="label">Email Cost:</span>
              <span className="value">{formatCurrency(monthlyPrice, currency)}</span>
            </div>
            
            {/* Discount Breakdown */}
            {discountPercentage > 0 && (
              <>
                <div className="breakdown-row discount">
                  <span className="label">Discount ({discountPercentage}%):</span>
                  <span className="value discount-amount">-{formatCurrency(discountAmount, currency)}</span>
                </div>
                <div className="breakdown-row discounted-price">
                  <span className="label">After Discount:</span>
                  <span className="value">{formatCurrency(discountedPrice, currency)}</span>
                </div>
              </>
            )}
            
            <div className="breakdown-row total">
              <span className="label">Monthly Total:</span>
              <span className="value">{formatCurrency(discountPercentage > 0 ? discountedPrice : monthlyPrice, currency)}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits Message */}
      {monthlyPrice > 0 && (
        <div className="benefits-message">
          <div className="benefits-icon">✨</div>
          <h4>What's Included</h4>
          <ul>
            <li>Advanced email editor & templates</li>
            <li>Automation workflows</li>
            <li>Detailed analytics & reporting</li>
            <li>24/7 customer support</li>
            <li>API access & integrations</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default PriceResults;